/* eslint-disable jsx-a11y/anchor-is-valid */
import { Table } from 'antd';
import { billingSelectors } from 'containers/App/selectors';
import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

const TablePatient: FC = () => {
  const { hospitalForCpap, fieldHospital } = useSelector(billingSelectors);
  const hospitalVisitOption = useMemo(() => {
    const result = fieldHospital?.find(([_key, value]: [string, any]) => value.display_id === 'hospital_visit');
    if (!result) {
      return [];
    }
    return result[1].options;
  }, [fieldHospital]);

  const columns: any = [
    {
      title: '年月度',
      dataIndex: 'target_month',
      key: 'target_month',
      width: '25%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
            className: 'standardFont',
          },
          children: (
            <div>
              {text.slice(0, 4)}年{+text.slice(4)}月度
            </div>
          ),
        };
      },
    },
    {
      title: '受診 XO',
      key: 'hospital_visit',
      dataIndex: 'hospital_visit',
      width: '10%',
      align: 'center',
      render(text: string) {
        const visitType = checkHospitalVisit(text, hospitalVisitOption);
        return {
          props: {
            style: { textAlign: 'center' },
            className: 'standardFont',
          },
          children: !visitType ? null : visitType === 'o_yes' ? (
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                {' '}
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                  fill="black"
                />{' '}
              </svg>
            </div>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <div style={{ position: 'relative' }}>
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect
                    x="0.1875"
                    y="3.1687"
                    width="4.4812"
                    height="26.8872"
                    transform="rotate(-45 0.1875 3.1687)"
                    fill="black"
                  />
                </svg>
                <svg
                  style={{ position: 'absolute', left: 0 }}
                  width="23"
                  height="23"
                  viewBox="0 0 23 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="19.0117" width="4.4812" height="26.8872" transform="rotate(45 19.0117 0)" fill="black" />
                </svg>
              </div>
            </div>
          ),
        };
      },
    },
    {
      title: '備考',
      key: 'hospital_visit_remark',
      dataIndex: 'hospital_visit_remark',
      width: '50%',
      align: 'center',
      padding: '0px',
      render(text: string) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left', padding: '0px' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
  ];

  return (
    <div>
      <Table columns={columns} dataSource={hospitalForCpap?.items || []} pagination={false} />
    </div>
  );
};

const checkHospitalVisit = (text: string, options: any[]) => {
  const find = options.find((f) => f.value === text);

  if (find) {
    return find.display_id;
  }
  return '';
};

export default TablePatient;
